import { Component, OnInit } from '@angular/core';
import {DeviceService} from '../../../services/device.service';

@Component({
  selector: 'app-sticky-close-dialog',
  templateUrl: './sticky-close-dialog.component.html',
  styleUrls: ['./sticky-close-dialog.component.scss']
})
export class StickyCloseDialogComponent implements OnInit {

  readonly DIALOG_CLOSE_OPACITY_DELAY = 300;
  dialogCloseVisible: boolean;

  constructor(public deviceService: DeviceService) { }

  ngOnInit() {
    this.dialogCloseVisible = !this.deviceService.isSafari;
    setTimeout(() => this.dialogCloseVisible = true, this.DIALOG_CLOSE_OPACITY_DELAY);
  }

}
